import { render, staticRenderFns } from "./testOverview.vue?vue&type=template&id=7b6643f8&scoped=true&"
import script from "./testOverview.vue?vue&type=script&lang=js&"
export * from "./testOverview.vue?vue&type=script&lang=js&"
import style0 from "./testOverview.vue?vue&type=style&index=0&id=7b6643f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6643f8",
  null
  
)

export default component.exports